import { BaseFirestoreService } from "../FirestoreService";
import { ForumPost, FORUMS_COLLECTION, FORUMS_POST_LIKES_COUNT_FIELD, FORUMS_POST_REPLIES_COUNT_FIELD, FORUMS_POST_TIMESTAMP_FIELD, FORUMS_REPLIES_COLLECTION } from "../../db";
import { FirestoreTimestampServerValue } from "../../db/common";
import { ForumPostRepliesService } from "./ForumPostRepliesService";
import { ForumPostLikesService } from "./ForumPostLikesService";

/**
 * Shared Forum Service
 * Works with both Firebase Admin SDK (backend) and Client SDK (frontend)
 */
export class ForumPostService extends BaseFirestoreService<ForumPost> {
    protected getCollectionPath(): string {
        return FORUMS_COLLECTION;
    }

    public getRepliesCollectionGroup() {
        return this.firestore.collectionGroup(FORUMS_REPLIES_COLLECTION)
    }

    public postReplyService(postId: string): ForumPostRepliesService {
        return new ForumPostRepliesService(this.firestore, postId)
    }

    public postLikeService(postId: string): ForumPostLikesService {
        return new ForumPostLikesService(this.firestore, postId)
    }

    //@overwrite no need to specify some args
    create(data: Omit<ForumPost,
        typeof FORUMS_POST_TIMESTAMP_FIELD
        | typeof FORUMS_POST_LIKES_COUNT_FIELD
        | typeof FORUMS_POST_REPLIES_COUNT_FIELD
        | 'reply_disabled'>): Promise<string> {
        return super.create({
            ...data,
            timestamp: FirestoreTimestampServerValue,
            replies_count: 0,
            likes_count: 0,
            reply_disabled: false,
        })
    }
}

